import { NgModule } from '@angular/core';

import { InformationPagesRoutingModule } from './information-pages-routing.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { SharedModule } from '../../shared/shared.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';


@NgModule({
    declarations: [AboutUsComponent, PrivacyPolicyComponent, TermsConditionsComponent],
    imports: [
        SharedModule,
        InformationPagesRoutingModule
    ]
})
export class InformationPagesModule {
}
